import { useRef } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { useAdminUser } from "../../http/serviceportalApi";
import { useTranslations } from "../../hooks/useTranslations";
import ErrorText from "../ui/ErrorText";
import LoadingSpinner from "../ui/LoadingSpinner";
import NavTabs from "../ui/NavTabs";
import Page from "../ui/Page";
import ShortInfo from "../ui/ShortInfo";
import styles from "./AdminUser.module.css";
import AdminUserAssignments from "./AdminUserAssignments";
import AdminUserInfos from "./AdminUserInfos";

const AdminUser = () => {
  const { i18n } = useTranslations();
  const { userId } = useParams();
  const aborter = useRef(new AbortController());
  const {
    data: user,
    isValidating,
    error,
  } = useAdminUser(userId, aborter.current.signal);
  const displayName = user
    ? user.name
      ? user.name
      : `${user.firstName} ${user.lastName}`
    : i18n.notAvailable;

  return (
    <>
      <Page
        title={isValidating ? "" : displayName}
        shortInfo={
          !isValidating ? (
            <ShortInfo title={i18n.admin.user.id}>
              {user?.id ?? i18n.notAvailable}
            </ShortInfo>
          ) : undefined
        }
        backLinkText={i18n.admin.user.backLink}
      >
        <NavTabs
          tabs={[
            { to: "infos", text: i18n.admin.user.tabs.infos },
            { to: "zugriff", text: i18n.admin.user.tabs.assignments },
          ]}
        />
        {isValidating && (
          <div className={styles.status}>
            <LoadingSpinner />
          </div>
        )}
        {error && (
          <div className={styles.status}>
            <ErrorText text={i18n.admin.user.loadError} />
          </div>
        )}
        {user && (
          <Routes>
            <Route path="infos" element={<AdminUserInfos user={user} />} />
            <Route
              path="zugriff"
              element={<AdminUserAssignments userId={user.id} />}
            />
            <Route path="*" element={<Navigate to="infos" replace />} />
          </Routes>
        )}
      </Page>
    </>
  );
};

export default AdminUser;
